import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useNotificacoesPopoverStore = defineStore('notificacoesPopover', () => {
    const closeNotificacoesPopover = ref(false);

    function triggerCloseNotificacoesPopover() {
        closeNotificacoesPopover.value = true;
    }

    function resetCloseNotificacoesPopover() {
        closeNotificacoesPopover.value = false;
    }

    return {
        closeNotificacoesPopover,
        triggerCloseNotificacoesPopover,
        resetCloseNotificacoesPopover
    };
});
